import { createTrignometryOperator } from "./_internal";
const $asin = createTrignometryOperator(Math.asin);
export {
  $asin
};
